import { render, staticRenderFns } from "./PlantTop.vue?vue&type=template&id=f870c020&lang=html"
import script from "./PlantTop.vue?vue&type=script&lang=js"
export * from "./PlantTop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports